var _defs, _rect, _g, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 100",
    width: 760,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .red {\r\n                fill: #B22234;\r\n            }\r\n\r\n            .white {\r\n                fill: #FFFFFF;\r\n            }\r\n\r\n            .blue {\r\n                fill: #3C3B6E;\r\n            }\r\n        "), /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "-1 -1 2 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "white",
    points: "0,-1 0.224514,-0.309017 0.951057,-0.309017 0.363271,0.118034                 0.587785,0.809017 0,0.381966 -0.587785,0.809017                 -0.363271,0.118034 -0.951057,-0.309017 -0.224514,-0.309017"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "red",
    width: 190,
    height: 100
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7.6923077,
    width: 190,
    height: 7.6923077
  }), /*#__PURE__*/React.createElement("rect", {
    y: 23.0769231,
    width: 190,
    height: 7.6923077
  }), /*#__PURE__*/React.createElement("rect", {
    y: 38.4615385,
    width: 190,
    height: 7.6923077
  }), /*#__PURE__*/React.createElement("rect", {
    y: 53.8461539,
    width: 190,
    height: 7.6923077
  }), /*#__PURE__*/React.createElement("rect", {
    y: 69.2307693,
    width: 190,
    height: 7.6923077
  }), /*#__PURE__*/React.createElement("rect", {
    y: 84.6153847,
    width: 190,
    height: 7.6923077
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "blue",
    x: 0,
    y: 0,
    width: 76,
    height: 53.8461539
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(0.0, 0.0) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate( 6.3333333, 5.38461539) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(18.9999999, 5.38461539) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(31.6666665, 5.38461539) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(44.3333331, 5.38461539) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(57.0,        5.38461539) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(69.6666666, 5.38461539) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(12.6666666,10.76923078) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(25.3333332,10.76923078) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(37.9999998,10.76923078) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(50.6666664,10.76923078) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(63.3333330,10.76923078) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate( 6.3333333,16.15384617) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(18.9999999,16.15384617) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(31.6666665,16.15384617) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(44.3333331,16.15384617) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(57.0,       16.15384617) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(69.6666666,16.15384617) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(12.6666666,21.53846156) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(25.3333332,21.53846156) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(37.9999998,21.53846156) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(50.6666664,21.53846156) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(63.3333330,21.53846156) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate( 6.3333333,26.92307695) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(18.9999999,26.92307695) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(31.6666665,26.92307695) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(44.3333331,26.92307695) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(57.0,       26.92307695) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(69.6666666,26.92307695) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(12.6666666,32.30769234) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(25.3333332,32.30769234) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(37.9999998,32.30769234) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(50.6666664,32.30769234) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(63.3333330,32.30769234) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate( 6.3333333,37.69230773) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(18.9999999,37.69230773) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(31.6666665,37.69230773) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(44.3333331,37.69230773) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(57.0,       37.69230773) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(69.6666666,37.69230773) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(12.6666666,43.07692312) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(25.3333332,43.07692312) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(37.9999998,43.07692312) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(50.6666664,43.07692312) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(63.3333330,43.07692312) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate( 6.3333333,48.46153851) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(18.9999999,48.46153851) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(31.6666665,48.46153851) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(44.3333331,48.46153851) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(57.0,       48.46153851) scale(3.08)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star",
    transform: "translate(69.6666666,48.46153851) scale(3.08)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnflag);
export default __webpack_public_path__ + "static/media/enflag.c532d821f0a53963b1bfbbd9cc1b432f.svg";
export { ForwardRef as ReactComponent };